import { useSelector } from 'react-redux';
import { Navigate, Route, Routes } from 'react-router-dom';

// Components
import { Col } from 'components';
import CtaAuth from './CtaAuth';
import CtaIntro from './CtaIntro';
import CtaPostShoutout from './CtaPostShoutout';
import GradientBackground from './GradientBackground';
import ShoutoutSent from './ShoutoutSent';

/*
  Step routes of the CTA shoutout flow: index (intro), signup, login, compose,
  success. Each step guards its own auth state.
*/
const CtaRoutes = ({ basePath, otherUser, onStart, onLogin, onAuthComplete, onContinueInApp }) => {
  const { isMobile } = useSelector((state) => state.appState);
  const currentUser = useSelector((state) => state.user);

  // username/onboarding is NOT required here — a fresh social signup goes straight to compose
  const isLoggedIn = !!currentUser?._id;

  return (
    <Routes>
      <Route
        index
        element={
          <GradientBackground>
            <Col wid={isMobile ? '100%' : '300px'} center between>
              <CtaIntro otherUser={otherUser} onStart={onStart} onLogin={onLogin} />
            </Col>
          </GradientBackground>
        }
      />

      <Route
        path="signup"
        element={
          isLoggedIn ? (
            <Navigate to={`${basePath}/compose`} replace />
          ) : (
            <GradientBackground justify="flex-start">
              <Col wid={isMobile ? '100%' : '400px'} center between>
                <CtaAuth otherUser={otherUser} onAuthComplete={onAuthComplete} />
              </Col>
            </GradientBackground>
          )
        }
      />

      <Route
        path="login"
        element={
          isLoggedIn ? (
            <Navigate to={`${basePath}/compose`} replace />
          ) : (
            <GradientBackground justify="flex-start">
              <Col wid={isMobile ? '100%' : '400px'} center between>
                <CtaAuth isLogin otherUser={otherUser} onAuthComplete={onAuthComplete} />
              </Col>
            </GradientBackground>
          )
        }
      />

      <Route
        path="compose"
        element={
          isLoggedIn ? (
            <GradientBackground justify="flex-start">
              <Col wid={isMobile ? '100%' : '400px'} center noFlex>
                <CtaPostShoutout basePath={basePath} otherUser={otherUser} />
              </Col>
            </GradientBackground>
          ) : (
            <Navigate to={basePath} replace />
          )
        }
      />

      <Route
        path="success"
        element={
          isLoggedIn ? (
            <GradientBackground>
              <Col wid={isMobile ? '100%' : '400px'} center noFlex>
                <ShoutoutSent otherUser={otherUser} onContinueInApp={onContinueInApp} />
              </Col>
            </GradientBackground>
          ) : (
            <Navigate to={basePath} replace />
          )
        }
      />

      <Route path="*" element={<Navigate to={basePath} replace />} />
    </Routes>
  );
};

export default CtaRoutes;
